import React from 'react';
import { ICard } from '../../types/card';
import Card from './Card';

interface CardGridProps {
  numberOfCols: 2 | 3 | 4;
  cardData: ICard[];
}

/**
 * Wrapper component that displays a grid of cards
 *
 * @param numberOfCols - Number of columns per row. Either : 2 | 3 | 4
 * @param cardData
 * @returns
 */
const CardGrid: React.FC<CardGridProps> = ({ cardData, numberOfCols }) => {
  const colVariants = {
    2: 'grid sm:grid-cols-2 md:grid-cols-2',
    3: 'grid sm:grid-cols-2 md:grid-cols-3',
    4: 'grid sm:grid-cols-2 md:grid-cols-4',
  };

  return (
    <div
      className={`grid w-full h-full gap-y-6 gap-x-6 md:gap-x-4 xl:gap-x-8 ${colVariants[numberOfCols]}`}
    >
      {cardData.map(card => (
        <div key={card.header}>
          <Card cardData={card} />
        </div>
      ))}
    </div>
  );
};

export default CardGrid;
